import React from 'react';
import styled from '@emotion/styled';

interface ActionButtonProps {
  url: string;
  text?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ url, text = "판매 페이지로 이동" }) => {
  return (
    <Button onClick={() => window.location.href = url}>
      <ButtonText>{text}</ButtonText>
      <ArrowIcon>→</ArrowIcon>
    </Button>
  );
};

const Button = styled.button`
  width: 100%;
  background-color: #4B7AFB;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
`;

const ButtonText = styled.span`
  margin-right: 8px;
`;

const ArrowIcon = styled.span`
  font-size: 18px;
`;